import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Modal, Form, Input, Button, message } from "antd";
import { useCreateIssueMutation } from "../../../Redux/service/CallCenter/CallCenter";
import trans from "../../../utils";

const { TextArea } = Input;

const CreateIssueModal = ({ visible, onClose, modelId, onSuccess }) => {
  const [form] = Form.useForm();
  const [createIssue, { isLoading }] = useCreateIssueMutation();
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";

  const handleSubmit = async (values) => {
    try {
      const result = await createIssue({
        modelId: Number(modelId),
        title: values.title,
        titleAr: values.titleAr,
        description: values.description || undefined,
        descriptionAr: values.descriptionAr || undefined,
      }).unwrap();

      message.success(
        lang === "ar" ? "تم إنشاء العيب بنجاح" : "Issue created successfully"
      );
      form.resetFields();
      onSuccess(result.data);
      onClose();
    } catch (err) {
      message.error(err?.data?.message || "Something went wrong");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return createPortal(
    <Modal
      title={lang === "ar" ? "إضافة عيب جديد" : "Add New Issue"}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      zIndex={2000}
      destroyOnClose={true}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={lang === "ar" ? "العنوان (إنجليزي)" : "Title (English)"}
          name="title"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input placeholder={lang === "ar" ? "أدخل العنوان بالإنجليزية" : "Enter title in English"} />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "العنوان (عربي)" : "Title (Arabic)"}
          name="titleAr"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input
            placeholder={lang === "ar" ? "أدخل العنوان بالعربية" : "Enter title in Arabic"}
            dir="rtl"
          />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الوصف (إنجليزي)" : "Description (English)"}
          name="description"
        >
          <TextArea
            rows={3}
            placeholder={lang === "ar" ? "أدخل الوصف بالإنجليزية" : "Enter description in English"}
          />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الوصف (عربي)" : "Description (Arabic)"}
          name="descriptionAr"
        >
          <TextArea
            rows={3}
            placeholder={lang === "ar" ? "أدخل الوصف بالعربية" : "Enter description in Arabic"}
            dir="rtl"
          />
        </Form.Item>

        <div className="d-flex justify-content-end gap-2">
          <Button onClick={handleCancel}>
            {lang === "ar" ? "إلغاء" : "Cancel"}
          </Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {lang === "ar" ? "إنشاء" : "Create"}
          </Button>
        </div>
      </Form>
    </Modal>,
    document.body
  );
};

export default CreateIssueModal;
